<h6>Daily time of use cost (100 day average)</h6>
<div id="containeTOUGraph" style="width: 500px;"></div>